<template>
  <div>
    <v-flex xs12 sm12 d-block class="card-dados">
      <v-list>
        <v-list-tile class="lista">
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="bolinha">1</span>
              Identificação
              <span class="red--text">*</span>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              <label><strong class="primary--text">CNPJ</strong></label>
              <v-layout row wrap>
                <v-flex xs12 sm12 d-flex>
                  <combo-autocomplete-search-api
                      :value="getFornecedorFormatado"
                      :validate="{ required: true }"
                      name="Fornecedor"
                      data-test="autocomplete.fornecedor"
                      :loading="loadingBuscaFornecedores"
                      :items="fornecedores"
                      :has-more="hasMaisFornecedores"
                      item-text="nomeRazaoSocial"
                      item-value="id"
                      show-action
                      return-object
                      placeholder-search="Informe o CPF/CNPJ/Nome/Razão Social"
                      placeholder="Busque e selecione um Fornecedor"
                      :no-data-text="mensagemBuscaFornecedor"
                      @filter-search="tratarEventoBuscarFornecedor"
                      @load-more="tratarEventoCarregarMaisFornecedores"
                      @input="tratarEventoFornecedorSelecionado"
                      @clear-search="setMensagemBuscaFornecedor"
                  >
                    <template #itemText="{ item }">
                      <v-list-tile-sub-title>{{ item.cpfCnpj | azCpfCnpj }} - {{ item.nomeRazaoSocial }} </v-list-tile-sub-title>
                    </template>
                  </combo-autocomplete-search-api>
                  </v-flex>
                <v-flex v-if="camposBloqueados" class="red--text mt-2" data-test="alerta.proposta-enviada">
                  A proposta deste fornecedor já foi enviada.
                </v-flex>
              </v-layout>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="lista">
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="bolinha">2</span>
              Prazo de Validade da Proposta
              <span class="red--text">*</span>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              <label><strong class="primary--text">Validade da Proposta (em dias)</strong></label>
              <v-flex xs12 sm4 d-flex>
                <v-text-field name="Validade da Proposta"
                              placeholder="Ex. 60"
                              :error-messages="errors.collect('Validade da Proposta')"
                              v-model.number="valor.validadeProposta"
                              @keydown="limparStringDigitada($event)"
                              v-validate="'integer|required|max:9|min_value:1'"
                              :disabled="camposBloqueados"/>
              </v-flex>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="lista">
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="bolinha">3</span>
              Prazo de Garantia
            </v-list-tile-title>
            <v-list-tile-sub-title>
              <label><strong class="primary--text">Prazo de garantia (em dias)</strong></label>
              <v-flex xs12 sm4 d-flex>
                <v-text-field name="Prazo de Garantia"
                              placeholder="Ex. 120"
                              :error-messages="errors.collect('Prazo de Garantia')"
                              v-model.number="valor.prazoGarantia"
                              @keydown="limparStringDigitada($event)"
                              v-validate="'integer|max:9|min_value:0'"
                              :disabled="camposBloqueados"/>
              </v-flex>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="lista">
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="bolinha">4</span>
              Prazo de Entrega dos Produtos/Serviços
              <span class="red--text">*</span>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              <label><strong class="primary--text">Prazo de Entrega (em dias)</strong></label>
              <v-flex xs12 sm4 d-flex>
                <v-text-field
                    filled
                    placeholder="Ex. 10"
                    name="Prazo de Entrega"
                    maxlength="100"
                    v-model.number="valor.prazoEntregaDescritivo"
                    @keydown="limparStringDigitada($event)"
                    :error-messages="errors.collect('Prazo de Entrega')"
                    v-validate="'integer|required|min_value:0'"
                    :disabled="camposBloqueados"
                ></v-text-field>
              </v-flex>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-flex>

    <div class="az-actions-form acao-botao">
      <botao-voltar @voltar="tratarEventoVoltar"/>
      <botao-salvar-avancar @salvarEAvancar="tratarEventoDeAvancar" v-if="!camposBloqueados"/>
      <botao-avancar id="botaoAvancar" @avancar="irParaProposta" v-else/>
    </div>
  </div>
</template>

<script>

import azCpfCnpj from '@azinformatica/loki/src/filters/cpf-cnpj'
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'

export default {
    name: 'CompradorIncluirPropostaManualTermo',
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            valor: {
                aceiteTermo: false,
                termoResponsabilidade: false
            },
            textoAceite: 'Declaro que estou ciente e concordo com as condições desta compra direta.',
            textoResponsabilidade: 'Declaro a responsabilidade pelas transações efetuadas no sistema.',
            mensagemBuscaFornecedor: 'Não há dados disponíveis',
            fornecedores: [],
            loadingBuscaFornecedores: false,
            paginacaoFornecedores: {
                page: 1,
                rowsPerPage: 10,
                sort: 'ASC',
                sortBy: 'id'
            },
            totalPagesFornecedores: 0,
            buscaFornecedorAtual: null,
            exibirModalFormularioFornecedor: false,
            dadosCadastroFornecedor: {
                documento: null,
                nome: null,
            },
            displayNomeEmpresarial: null,
            displayCnpj: null,
            fornecedorId: null,
            propostaId: null,
            compraDiretaId: null,
        }
    },
    created() {
        const id = this.$route && this.$route.params ? this.$route.params.id : null
        this.compraDiretaId = id ? Number(id) || id : null
    },
    mounted() {
        const { propostaId, fornecedorId, displayNomeEmpresarial, displayCnpj } = this.$route.params || {}
        if (propostaId) this.propostaId = propostaId
        if (fornecedorId) this.fornecedorId = fornecedorId
        if (displayNomeEmpresarial) this.displayNomeEmpresarial = displayNomeEmpresarial
        if (displayCnpj) this.displayCnpj = displayCnpj
        if (this.fornecedorId) {
            this.buscarTermos()
        }
    },
    computed: {
        ...mapState(['resumoProposta', 'parametros']),
        propostaEnviada() {
            if (this.resumoProposta.tipo === 'SEM_DISPUTA' && this.resumoProposta.situacaoProposta === 'ENVIADA') {
                return true
            } else if (this.resumoProposta.tipo === 'SEM_DISPUTA' && this.resumoProposta.situacaoProposta === 'EM_ELABORACAO') {
                return false
            } else if (this.resumoProposta.tipo === 'COM_DISPUTA' && this.resumoProposta.situacaoProposta === 'EM_ELABORACAO' && !this.resumoProposta.tempoRandomico) {
                return false
            } else if (this.resumoProposta.tipo === 'COM_DISPUTA' && this.resumoProposta.situacaoProposta === 'ENVIADA' && !this.resumoProposta.tempoRandomico) {
                return true
            } else {
                return this.resumoProposta.tipo === 'COM_DISPUTA' && this.resumoProposta.tempoRandomico
            }
        },
        camposBloqueados() {
            return !!(this.propostaEnviada && this.fornecedorId && this.propostaId)
        },
        cotacao: {
            get() {
                return this.value
            },
            set(newValue) {
                this.$emit('input', newValue)
            },
        },
        getFornecedorFormatado() {
            if (!this.displayCnpj) {
                return null
            }

            return `${azCpfCnpj(this.displayCnpj)} - ${this.displayNomeEmpresarial}`
        },
        getCnpjFormatado() {
            if (!this.displayCnpj) {
                return '--'
            }

            return `${azCpfCnpj(this.displayCnpj)}`
        },
        hasMaisFornecedores() {
            return this.totalPagesFornecedores > this.paginacaoFornecedores.page
        }
    },
    methods: {
        async salvar() {
            this.valor.salvarAutomatico = true
            const termosObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId,
                termos: this.valor
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.SALVAR_TERMOS, termosObj)
        },
        irParaProposta() {
            const id = this.$route.params.id
            const propostaId = this.propostaId
            const fornecedorId = this.fornecedorId
            const displayNomeEmpresarial = this.displayNomeEmpresarial
            const displayCnpj = this.displayCnpj
            this.$router.push({ name: 'CompradorIncluirPropostaManualProposta', params: { id, propostaId, fornecedorId, displayNomeEmpresarial, displayCnpj } })
        },
        tratarEventoVoltar() {
            this.$router.push({name: 'Resultado'})
        },
        fechar() {
            this.$router.back()
        },
        async tratarEventoBuscarFornecedor(conteudo) {
            this.buscaFornecedorAtual = conteudo
            this.paginacaoFornecedores.page = 1
            this.totalPagesFornecedores = 0
            try {
                this.loadingBuscaFornecedores = true
                const { itens, totalPages } = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_LISTAGEM_PAGINADA, {
                    conteudo,
                    paginacao: this.paginacaoFornecedores
                })
                this.fornecedores = itens || []
                this.totalPagesFornecedores = Number(totalPages || 0)
                this.setMensagemBuscaFornecedor(conteudo)
            } finally {
                this.loadingBuscaFornecedores = false
            }
        },
        async tratarEventoCarregarMaisFornecedores() {
            if (this.loadingBuscaFornecedores) return
            if (!this.buscaFornecedorAtual) return
            if (!this.hasMaisFornecedores) return
            try {
                this.loadingBuscaFornecedores = true
                const proximaPagina = this.paginacaoFornecedores.page + 1
                const { itens } = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_LISTAGEM_PAGINADA, {
                    conteudo: this.buscaFornecedorAtual,
                    paginacao: { ...this.paginacaoFornecedores, page: proximaPagina },
                })
                this.paginacaoFornecedores.page = proximaPagina
                this.fornecedores = [...this.fornecedores, ...(itens || [])]
            } finally {
                this.loadingBuscaFornecedores = false
            }
        },
        async tratarEventoFornecedorSelecionado(fornecedor) {
            if (!fornecedor) {
                this.displayNomeEmpresarial = null
                this.displayCnpj = null
                this.fornecedorId = null
                this.propostaId = null
                this.valor.validadeProposta = null
                this.valor.prazoGarantia = null
                this.valor.prazoEntregaDescritivo = null
                return
            }
            this.displayNomeEmpresarial = fornecedor.nomeRazaoSocial
            this.displayCnpj = fornecedor.cpfCnpj
            this.fornecedorId = fornecedor.id
            this.propostaId = null
            this.fornecedores = []
            this.valor.validadeProposta = null
            this.valor.prazoGarantia = null
            this.valor.prazoEntregaDescritivo = null
            this.buscarTermos()
        },
        async buscarTermos() {
            await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_TERMOS, {
                compraDiretaId: this.compraDiretaId,
                fornecedorId: this.fornecedorId
            })
            this.valor = this.$store.state.termos
            if (this.valor && this.valor.id) {
                this.propostaId = this.valor.id
                await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA, {
                    compraDiretaId: this.compraDiretaId,
                    propostaId: this.propostaId,
                    fornecedorId: this.fornecedorId
                })
            }
        },
        async tratarEventoDeAvancar() {
            await this.validarCamposObrigatorios()
            this.habilitarLoadingGlobal()
            await this.tratarEventoDeLancarProposta()
            await this.salvar()
            this.mostrarNotificacaoSucesso('Informações salva com sucesso!')
            this.irParaProposta()
        },
        async tratarEventoDeLancarProposta() {
            if (this.fornecedorId === null) {
                throw new Error('Fornecedor não selecionado.')
            }
            let fornecedorValido = null
            if(this.fourbillingAtivo){
                try {
                    fornecedorValido = await this.$store.dispatch(actionTypes.COMPRADOR.VALIDAR_PARA_PROPOSTA, {
                        compraDiretaId: this.compraDiretaId,
                        fornecedorId: this.fornecedorId
                    })
                } catch (err) {
                    if (err.message.includes('plano')){
                        this.mensagemErro = err.message
                        this.linkMensagemErro = {
                            texto: 'Visualizar Planos',
                            url: this.parametros.propriedadesCompraDiretas.urlVisualizarPlanos,
                            redirecionar: false
                        }
                        this.alertaAmarelo = true
                        this.exibirAlertaValidarFornecedor = true
                    } else {
                        throw new Error(err.message)
                    }
                }
            }else{
                try {
                    fornecedorValido = await this.$store.dispatch(actionTypes.COMPRADOR.VALIDAR_PARA_PROPOSTA, {
                        compraDiretaId: this.compraDiretaId,
                        fornecedorId: this.fornecedorId
                    })
                } catch (e) {
                    throw new Error('Fornecedor inválido.')
                }
              
            }

            if (fornecedorValido) {
                await this.$store.dispatch(actionTypes.COMPRADOR.CRIAR_TERMOS, {
                    compraDiretaId: this.compraDiretaId,
                    fornecedorId: this.fornecedorId
                })
                this.propostaId = this.$store.state.termos.id
            }
        },
        async validarCamposObrigatorios() {
            const estaValido = await this.$validator._base.validateAll()
            if (!estaValido) {
                throw new Error('Preencha os campos obrigatórios.')
            }
        },      
        setMensagemBuscaFornecedor(cpfCnpj) {
            if (!cpfCnpj) {
                this.mensagemBuscaFornecedor = 'Não há dados disponíveis'
                this.fornecedores = []
                return
            }
            if (this.fornecedores.length === 0) {
                this.mensagemBuscaFornecedor = 'Fornecedor não cadastrado no e-Fornecedor'
            }
        },
        limparStringDigitada(evento){
            const teclasAceitaveis = ['Backspace', 'Delete', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown','Enter', 'Tab']
            if ((evento.keyCode < 48 || evento.keyCode > 57) && !this.ehTeclaNumerica(evento) && !teclasAceitaveis.includes(evento.key))
            {
                evento.preventDefault()
            }
        },
        ehTeclaNumerica(evento){
            return [96, 97, 98, 99, 100, 101, 102, 103, 104, 105].includes(evento.keyCode)
        },
    }
}
</script>

<style scoped>
.card-dados__titulo {
  font-size: 1.1rem;
}

.lista {
  padding: 8px 0;
}

.bolinha {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #1976d2;
  color: #fff;
  text-align: center;
  line-height: 18px;
  margin-right: 6px;
  font-size: 12px;
}
</style>
